module.exports = __webpack_public_path__ + "img/trw_trgametokens.6f40847.png";